import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '../components/ui'
import './AccessDenied.css'

function AccessDenied() {
  const navigate = useNavigate()
  const [imageHidden, setImageHidden] = useState(false)

  return (
    <div className="access-denied-page">
      <div className="access-denied-card">
        {!imageHidden && (
          <img
            className="access-denied-illustration"
            src="/images/access-denied-cute.png"
            alt="Иллюстрация: нет доступа"
            onError={() => setImageHidden(true)}
          />
        )}
        {imageHidden && <div className="access-denied-fallback">🐣</div>}
        <h1>Доступ ограничен</h1>
        <p>
          У вас нет прав для просмотра этой страницы. Обратитесь к администратору,
          чтобы получить доступ.
        </p>
        <Button type="button" variant="primary" onClick={() => navigate('/')}>
          Перейти на главную
        </Button>
      </div>
    </div>
  )
}

export default AccessDenied

